import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DeleteHook from "../../Hooks/DeleteHook";
import AdminDoctorDetailsModal from "../AdminDashboard/AdminDashboardDoctors/AdminDoctorDetailsModal";
import ResellerEditProfileModal from "./SuperAdminModal/ResellerEditProfileModal";

const SuperAdminAllDoctorTable = ({ doctorData, setRefetch, refetch }) => {
  const [selectedDoctorData, setSelectedDoctorData] = useState(null);
  const [modalIsOpenDoctorEditProfile, setModalIsOpenDoctorEditProfile] =
    useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  function closeModal() {
    setSelectedDoctor(null);
  }

  function openModal(doctor) {
    setSelectedDoctor(doctor);
  }

  const openModalDoctorEditProfile = (doctor) => {
    setSelectedDoctorData(doctor);
    setModalIsOpenDoctorEditProfile(true);
  };

  const closeModalDoctorEditProfile = () => {
    setModalIsOpenDoctorEditProfile(false);
  };

  return (
    <tr className="hover:bg-slate-50/50 transition-colors">
      <td className="px-6 py-4 text-xs font-bold text-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-blue-50 text-blue-700 font-extrabold flex items-center justify-center">
            {(doctorData.name || "D").substring(0, 1).toUpperCase()}
          </div>
          <span>{doctorData.name}</span>
        </div>
      </td>
      <td className="px-6 py-4 text-xs font-medium text-slate-500">
        {doctorData.email}
      </td>
      <td className="px-6 py-4 text-xs font-medium text-slate-500">
        {doctorData.phone || "N/A"}
      </td>
      <td className="px-6 py-4 text-xs">
        <span className="bg-blue-50 text-blue-700 font-bold px-2.5 py-0.5 rounded-full text-[10px] tracking-wide uppercase border border-blue-100">
          {doctorData.role}
        </span>
      </td>
      <td className="px-6 py-4 text-xs">
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border ${doctorData?.isActive
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : "bg-rose-50 text-rose-700 border-rose-100"
            }`}
        >
          <span className={`w-1.5 h-1.5 rounded-full ${doctorData?.isActive ? "bg-emerald-500" : "bg-rose-500"}`} />
          {doctorData?.isActive ? "Active" : "Inactive"}
        </span>
      </td>
      <td className="px-6 py-4 text-xs">
        <div className="flex justify-end items-center gap-2">
          <button
            onClick={() => openModal(doctorData)}
            className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 border border-slate-200 hover:border-indigo-150 rounded-lg transition-all cursor-pointer"
            title="Edit profile & packages"
          >
            <Icon icon="basil:edit-outline" className="w-4 h-4" />
          </button>

          <button
            aria-label="Open delete confirmation"
            onClick={(e) => {
              DeleteHook({
                refetch,
                setRefetch,
                url: `https://servercareseebd.careseebd.com/api/v1/user/${doctorData?._id}`,
              });
            }}
            className="p-1.5 text-slate-400 hover:text-rose-600 hover:bg-rose-50 border border-slate-200 hover:border-rose-150 rounded-lg transition-all cursor-pointer"
            title="Delete Doctor"
          >
            <Icon icon="material-symbols:delete-outline" className="w-4 h-4" />
          </button>

          <Link
            to={`super-admin-view-all-patient/${doctorData._id}`}
            className="p-1.5 text-slate-400 hover:text-cyan-600 hover:bg-cyan-50 border border-slate-200 hover:border-cyan-150 rounded-lg transition-all cursor-pointer"
            title="View Doctor's Patients"
          >
            <Icon icon="grommet-icons:view" className="w-4 h-4" />
          </Link>
        </div>
      </td>

      <ResellerEditProfileModal
        resellerData={selectedDoctorData}
        isOpen={modalIsOpenDoctorEditProfile}
        closeModal={closeModalDoctorEditProfile}
      />

      {selectedDoctor && (
        <AdminDoctorDetailsModal
          closeModal={closeModal}
          isOpen={selectedDoctor !== null}
          doctor={selectedDoctor}
          doctorId={selectedDoctor._id}
        />
      )}
    </tr>
  );
};

export default SuperAdminAllDoctorTable;
